import { render } from 'react-dom';
import { Provider } from 'react-redux';
import type { ComponentType } from 'react';

import './utils/setupBlueprint';
import setupApiClient from './utils/setupApiClient';
import { store } from './redux/store';
import App from './App';

setupApiClient();

const renderApp = (TheApp: ComponentType = App) =>
    render(
        <Provider store={store}>
            <TheApp />
        </Provider>,
        document.querySelector('#app'),
    );

renderApp();
